
<template>
  <div class="modal fade" id="detectorForm" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div v-if="formSent">
            <div v-if="statusText" class="alert alert-success" role="alert">{{ statusText }}</div>
            <div v-if="statusError" class="alert alert-danger" role="alert">{{ statusError }}</div>
          </div>
          <form v-else>
            <div class="mb-3">
              <label class="form-label">ID</label>
              <input readonly type="text" class="form-control bg-light" v-model="formId">
            </div>
            <div class="mb-3">
              <label class="form-label">Ort</label>
              <input readonly type="text" class="form-control bg-light" v-model="formLocality">
            </div>
            <div class="mb-3">
              <label class="form-label">Beschreibung</label>
              <input type="text" class="form-control" v-model="formDescription">
            </div>
            <div class="mb-3">
              <label class="form-label">Kommentar</label>
              <textarea id="detectorFormComment" class="form-control" :class="{'is-invalid': !validateForm()}" rows="3" placeholder="Ihr Kommentar" v-model="formComment"></textarea>
              <div class="invalid-feedback">Dieses Feld wird benötigt.</div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button v-if="formSent" type="button" class="btn btn-secondary" data-bs-dismiss="modal">Schließen</button>
          <button v-else @click="sendForm" type="button" class="btn btn-secondary">Abschicken</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import {defineProps, ref, onMounted, computed, watch} from "vue";
import { useStore } from "vuex";

const store = useStore();

const formSent = ref(false);

const statusError = computed(() => {
  return store.getters.rwmFormResponseError;
});

const statusText = computed(() => {
  return store.getters.rwmFormResponseMessage;
});


const props = defineProps({
  id: {
    type: String,
    required: false,
  }
});

const detector = computed(() => props.id ? store.getters.detector(props.id) : null);
const formId = ref("");
const formLocality = ref("");
const formDescription = ref("");
const formComment = ref("");
const formCommentField = ref(null);

const validateForm = () => formComment.value.trim() !== "";

const sendForm = async() => {

  if (validateForm()) {
    formSent.value = true;
    await store.dispatch('sendRwmForm', {
      id: formId.value,
      locality: formLocality.value,
      description: formDescription.value,
      comment: formComment.value,
    });
  } else {
    formCommentField.value?.focus();
  }


}

watch(
    detector,
    (d) => {
      formId.value = d?.identifier ?? "";
      formLocality.value = d?.Locality ?? "";
      formDescription.value = d?.DESCRIPTION ?? "";
      formComment.value = "";
    },
    { immediate: true }
);

onMounted(() => {
  const modalForm = document.getElementById('detectorForm')
  modalForm.addEventListener('hidden.bs.modal', () => {
    formSent.value = false;
  });
  modalForm.addEventListener('shown.bs.modal', () => {
    formCommentField.value = document.getElementById('detectorFormComment');
    formCommentField.value?.focus();
  });
})

</script>

<style scoped>

</style>